/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { VideoSourceData } from '@osmosis/shared/types/learndb';

import { getHlsPlaylist } from '../lib/frontend/video/hls';
import { PROD_MEDIA_SERVER } from '@osmosis/constants';

export type SrcType = 'hls' | 's3' | 'yt';

export type SrcDataProps = {
  type?: SrcType;
  src: string;
};

/**
 * Gets the video src based on the provided data.
 */
const useVideoSrc = (data: VideoSourceData, mediaID?: number) => {
  const [srcData, setSrcData] = useState<SrcDataProps>({ src: '' });

  useEffect(() => {
    (async () => {
      if (data.hls) {
        const playlistUri = await getHlsPlaylist(data.hls, mediaID).catch(
          (e) => {
            console.error(e);
            console.error('Falling back to S3');
          },
        );

        if (playlistUri) {
          setSrcData({ src: playlistUri, type: 'hls' });
          return;
        }
      }

      if (data.s3) {
        setSrcData({ src: `${PROD_MEDIA_SERVER}${data.s3}`, type: 's3' });
        return;
      }

      if (data.yt) {
        setSrcData({
          src: `https://www.youtube.com/watch?v=${data.yt}`,
          type: 'yt',
        });
      }
    })();
  }, [data.hls, data.s3, data.yt, mediaID]);

  return srcData;
};

export default useVideoSrc;
